/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const updateProductItem = (componentRegistry) => {
  componentRegistry.useComponentPlugin("ProductItem", {
    name: "Customize Sort By", // Use PascalCase for component names
    enabled: true,
    apply: () => ({
      afterRender(element) {
        const sortingValue = document.querySelector(".boost-sd__sorting-value");
        const mobileToolbar = document.querySelector(".boost-sd__toolbar-top-mobile");

        if (sortingValue && window.innerWidth <= 767 && window.location.search === "") {
          sortingValue.textContent = "Sort By"; // Use textContent for setting text
        } else {
          console.error("Sort By element or mobile toolbar not found"); // Use console.error for errors
        }
      },
    }),
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   updateProductItem,
]);


